import { ChangeDetectionStrategy, Component, OnDestroy, OnInit, ViewContainerRef } from '@angular/core';
import { ValidationErrorKeys } from '@checkout/const';
import { CheckoutValidationService, DeliveryAddressService, ReceiptService } from '@checkout/feature';
import { UserGeoPointFacade } from '@city/data-access';
import { GeoPoint } from '@core/const';
import { ScrollToService } from '@shared/v2';
import { Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'sd-receipt-address',
  templateUrl: './receipt-address.component.html',
  styleUrls: ['./receipt-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorReceiptAddressComponent implements OnInit, OnDestroy {
  active$: Observable<string>;
  deliveryValidationErrors$: Observable<string[] | undefined>;
  pickupValidationErrors$: Observable<string[] | undefined>;
  currentCityMismatchValidationErrors$: Observable<string[] | undefined>;

  protected subscription = new Subscription();

  constructor(
    private receiptService: ReceiptService,
    private viewRef: ViewContainerRef,
    private checkoutValidationService: CheckoutValidationService,
    private scrollToService: ScrollToService,
    public deliveryAddressService: DeliveryAddressService,
    private userGeoPointFacade: UserGeoPointFacade,
  ) {}

  ngOnInit(): void {
    this.active$ = this.receiptService.activeReceiptTypeId$;
    this.deliveryValidationErrors$ = this.checkoutValidationService
      .getErrors(ValidationErrorKeys.DELIVERY_ADDRESS_REQUIRED)
      .pipe(map((errors) => errors && Object.values(errors)));

    this.pickupValidationErrors$ = this.checkoutValidationService
      .getErrors(ValidationErrorKeys.PICKUP_ADDRESS_REQUIRED)
      .pipe(map((errors) => errors && Object.values(errors)));

    this.currentCityMismatchValidationErrors$ = this.checkoutValidationService
      .getErrors(ValidationErrorKeys.DELIVERY_CITY_MISMATCH_WITH_CURRENT_CITY)
      .pipe(map((errors) => errors && Object.values(errors)));

    this.subscription.add(
      this.checkoutValidationService
        .getScrollToEvent(
          ValidationErrorKeys.DELIVERY_ADDRESS_REQUIRED,
          ValidationErrorKeys.PICKUP_ADDRESS_REQUIRED,
          ValidationErrorKeys.DELIVERY_CITY_MISMATCH_WITH_CURRENT_CITY,
          ValidationErrorKeys.SHOP_POSITION_NOT_AVAILABLE,
        )
        .subscribe(() => {
          this.scrollToService.scrollToElement(this.viewRef.element.nativeElement, {
            offset: -100,
          });
        }),
    );
  }

  setCorrectionCity(point: GeoPoint): void {
    this.userGeoPointFacade.setGeoPoint(point);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
